import { render, staticRenderFns } from "./NewEmailConf.vue?vue&type=template&id=8dea7fc6"
import script from "./NewEmailConf.vue?vue&type=script&lang=js"
export * from "./NewEmailConf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports